import React from "react";
import './Loader.css'

export default function Loader() {
  return (
    <div id="loader">
      <div className="loadingio-spinner-double-ring-f90snr8vj39">
        <div className="ldio-37rbbavuzaw">
          <div></div>
          <div></div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
}
